/**
 * Alarm type constants for the alarms library.
 * These constants should be used instead of hardcoded strings throughout the codebase.
 */
export const ALARM_TYPES = {
  DRONE_SENSE: 'DroneSense',
} as const;

/**
 * Type for alarm type values
 */
export type AlarmType = (typeof ALARM_TYPES)[keyof typeof ALARM_TYPES];
